import axios from "axios";

const apiValidacion = axios.create({
    baseURL: `${process.env.VUE_APP_API_URL}validacion`,
});

const apiUsuarios = axios.create({
    baseURL: `${process.env.VUE_APP_API_URL}usuarios`,    
});

const apiComercio = axios.create({
    baseURL: `${process.env.VUE_APP_API_URL}busquedaAlgolia`,
});

export { apiValidacion, apiUsuarios, apiComercio }
